import { Id } from "./id";

type ConfigurationProfile = {
  name: string;
  roles: Id[];
  columns: { key: string }[];
};

type ResourcesListingConfiguration = ConfigurationProfile[];

const resourcesListingConfiguration: ResourcesListingConfiguration = [];

export type { ResourcesListingConfiguration };

export { resourcesListingConfiguration };
